export default user => {
  let name = "";
  if (user.name || user.family) {
    if (user.name) {
      name = user.name;
    }
    if (user.family) {
      if (name) {
        name += ` ${user.family}`;
      } else {
        name += user.family;
      }
    }
  } else if (user.phone_number) {
    name = `${user.phone_number}`;
  }
  return name;
};

export const getUserFullNameWithEmptyState = user => {
  let name = "-----";
  if (user.name || user.family) {
    if (user.name) {
      name = user.name;
    }
    if (user.family) {
      if (name) {
        name += ` ${user.family}`;
      } else {
        name += user.family;
      }
    }
  }
  return name;
};

export const getUserNameWithMobile = user => {
  let name = "";
  if (user) {
    if (user.name || user.family) {
      name = `${user.name} ${user.family} (${user.phone_number})`;
    } else {
      name = user.phone_number;
    }
  }
  return name;
};
